
import { lazy } from 'react';

export const LazyAccounts = lazy(() => 
  import('@/pages/Accounts').then(module => ({ default: module.Accounts }))
);
